import { browserMode } from "@/shared/utils/browserMode"

export const currentTheme = () => {
  const { window } = browserMode()
  const userPrefersDark =
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches
  return userPrefersDark ? "dark" : "light"
}
